import React, { useState } from 'react'

import { Button, Grid, InputAdornment, InputLabel } from '@material-ui/core'
import CurrencyTextField from '@unicef/material-ui-currency-textfield'
import PropTypes from 'prop-types'

import styles from '../products.styles'

const EditQuantity = ({ data, handleSubmit, onCancel }) => {
  const [editedData, setEditedData] = useState(data)
  const classes = styles()

  const onSubmit = (event) => {
    event.preventDefault()
    handleSubmit(editedData)
  }

  return (
    <form noValidate onSubmit={onSubmit} autoComplete="off">
      <Grid container className={classes.root} justify="center">
        <Grid item xs={12} sm={12} md={6}>
          <InputLabel className={classes.labelSize}>Stock Total</InputLabel>
          <CurrencyTextField
            currencySymbol="#"
            textAlign="left"
            decimalPlaces={0}
            outputFormat="string"
            variant="outlined"
            inputProps={{
              defaultValue: editedData.stockQuantity,
              startAdornment: <InputAdornment position="start">#</InputAdornment>,
              inputProps: { min: 0 },
              onChange: ({ target }) =>
                setEditedData({ ...editedData, stockQuantity: Number(target.value) }),
            }}
          />
        </Grid>
      </Grid>
      <Grid container alignItems="center" justifyContent="center">
        <div className={classes.wrapper}>
          <Button
            variant="contained"
            className={`${classes.btnBackgroundErrorPrice} ${classes.btnUpload}`}
            btnErrorPrice
            onClick={onCancel}
          >
            Cancelar
          </Button>
        </div>
        <Button
          type="submit"
          className={`${classes.btnNewProduct} ${classes.btnUpload}`}
          label="Actualizar"
        >
          Actualizar
        </Button>
      </Grid>
    </form>
  )
}
EditQuantity.propTypes = {
  data: PropTypes.shape({
    stockQuantity: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  }).isRequired,
  handleSubmit: PropTypes.func.isRequired,
  onCancel: PropTypes.func.isRequired,
}

export default EditQuantity
